/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { put } from 'redux-saga/effects';

import { toggleSidebar } from '../actions';

// TODO: This saga is now a pass-through — it just forwards to toggleSidebar.
// Callers of updateSidebarState() could dispatch toggleSidebar() directly instead.
// @ts-ignore TODO: fix noImplicitAny error here
export function* updateSidebarStateSaga(action) {
  yield put(toggleSidebar(action.payload));
}
